import { Component, inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { FileUploaderComponent } from '@shared/components/file-uploader/file-uploader.component';
import { MatIcon } from '@angular/material/icon';
import { CarouselImage } from '@shared/interfacres/image';

@Component({
  selector: 'app-upload-image-dialog',
  templateUrl: 'upload-image-dialog.html',
  styleUrl: './upload-image-dialog.scss',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    FileUploaderComponent,
    MatIcon,
  ],
})
export class UploadImageDialog {
  readonly dialogRef = inject(MatDialogRef<UploadImageDialog>);
  readonly data = inject<CarouselImage>(MAT_DIALOG_DATA);

  url = '';

  file: File | null = null;
  image = '';

  constructor() {
      this.image = this.data?.image || '';
      this.url = this.data?.url || '';
  }

  attachFile(file: File[]) {
    this.file = file[0];

    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      this.image = event.target!.result as string;
    }
    reader.readAsDataURL(this.file);
  }

  save() {
    this.dialogRef.close({
      file: this.file,
      name: 'name',
      url: this.url || '',
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
